import React, {useState, useEffect} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, IconButton,Box, Tooltip} from '@mui/material';
import ConfirmationPopup from '../../Components/ConfirmationModal/confirmation-modal.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import UploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import '../../Components/Table/table-style.scss';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {validatePhoneNumber} from '../../Utils/PhoneNumberValidation/phone-number-validation.tsx';
import {validateDrivingLicense} from '../../Utils/DrivingLicenseValidation/driving-license-validation.tsx';
import {validateAadharNumber} from '../../Utils/AdharValidation/adhar-validation.tsx';
import {validateRemarks} from '../../Utils/RemarksValidation/remarks-validation.tsx'

import {editDriver , getDocuments ,addDocuments ,deleteDocument,editDocuments,getPincode} from './action.ts';
import {validateDriverName} from '../../Utils/NameValidation/name-validation.tsx';
import {validateEmail} from '../../Utils/EmailValidation/email-validation.tsx';

interface DriverData {
  name: string;
  location: string;
  phone: string;
  whatsapp_number: string;
  email: string;
  pincode?: string;
  state?:string;
  city?:string;
}
interface UploadedFile {
  location: string;
  id : number;
}
interface EditDriverModalProps {
  open: boolean;
  onClose: () => void;
  driverData: DriverData | null;
  driverId: number;
  fetchUsers: (page: number, pageSize: number, lead: string | null, blacklist: string | null, left: string | null,others:string|null, driverName:string|null, driverPhone:string|null, tabName: string) => void;
  page : number;
  pageSize : number;
}

const EditDriverModal: React.FC<EditDriverModalProps> = ({ open, onClose,driverData ,driverId ,fetchUsers ,page , pageSize }) => {
    const [file, setFile] = useState<{ [key: string]: File | null }>({});
    const [icons, setIcons] = useState<{ [key: string]: 'upload' | 'view' }>({
        aadhar: 'upload',
        drivinglicense: 'upload',
        pancard: 'upload',
        backgroundverification: 'upload'
    });
    const [selectedFiles, setSelectedFiles] = useState<{ [key: string]: File | null }>({
        drivinglicense: null,
        aadhar: null,
        pancard: null,
        backgroundverification: null
    });
    const [documentList, setDocumentList] = useState<any[]>([]);
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [documentToRemove, setDocumentToRemove] = useState<string | null>(null);
    const [documentDeleted, setDocumentDeleted] = useState(false);
    const [emailError, setEmailError] = useState<string>('');
    const [nameError , setNameError] = useState<string>('');
    const [whatsAppNumberError , setWhatsAppNumberError] = useState<string>('');
    const [locationError , setLocationError] = useState<string>('');
    const [aadharNumberError, setAadharNumberError] = useState<string>('');
    const [isPincodeFocused, setIsPincodeFocused] = useState(false);

    const [drivingLicenseError, setDrivingLicenseError] = useState<string>('');
    const resetState = () => {
      setEmailError('');
      setNameError('');
      setWhatsAppNumberError('');
      setLocationError('');
      setAadharNumberError('');
    };
    
    const [documentLocation, setDocumentLocation] = useState<string | null>(null);
    const maxFileSize = 1 * 1024 * 1024; 
    const allowedFileTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    const [aadharFilePending, setAadharFilePending] = useState<File | null>(null);
    const [drivingLicenseFilePending, setDrivingLicenseFilePending] = useState<File | null>(null);

    const [uploadedFiles, setUploadedFiles] = useState<{ [key: string]: UploadedFile | null }>({
         drivinglicense: null,
         aadhar: null,
         pancard: null,
         backgroundverification: null
    });
    const [initialDocValues, setInitialDocValues] = useState({
  aadhar_number: '',
  driving_license: ''
});
    const [documentState, setDocumentState] = useState(0);
    const [docTypeToDelete, setDocTypeToDelete] = useState<string | null>(null);
    const [countryCode, setCountryCode] = useState<string>('91');
    const [language, setLanguage] = useState<string>('EN');
    const [pincodeError, setPincodeError] = useState<string>('');
const [isFetchingPincode, setIsFetchingPincode] = useState<boolean>(false);
    const [formValues, setFormValues] = useState({
      name: '',
      location: '',
      phone: '',
      whatsapp_number: '',
      email: '',
      aadhar_number: '',
      driving_license:'',
      pincode: '',
      city: '',
  state: ''
    });
   const fetchDocuments = () => {
  if (driverId) {
    getDocuments(
      '',
      driverId,
      (response: any) => {
        const documentDetails = response.message?.user_documents || [];
        setDocumentList(documentDetails);
        const aadharDoc = documentDetails.find(doc => 
          doc.document_name.toLowerCase() === 'aadhar' && 
          doc.status === 'uploaded'
        );
        
       
        const drivingLicenseDoc = documentDetails.find(doc => doc.document_name.toLowerCase() === 'driving license' && doc.status === 'uploaded');
         setInitialDocValues({
          aadhar_number: aadharDoc?.document_number || '',
          driving_license: drivingLicenseDoc?.document_number || ''
        });
         setFormValues(prev => ({
          ...prev,
          aadhar_number: aadharDoc?.document_number || '',
          driving_license: drivingLicenseDoc?.document_number || ''
        }));
        const newIcons = {
          drivinglicense: 'upload',
          aadhar: 'upload',
          pancard: 'upload',
          backgroundverification: 'upload'
        };

        documentDetails.forEach(doc => {
          if (doc.status === 'uploaded') {
            const docType = doc.document_name.replace(' ', '').toLowerCase();
            newIcons[docType] = 'view';
          }
        });

        setIcons(newIcons);
        setDocumentState(2);
      },
      (errMessage: any) => {
        toast.error(errMessage);
      }
    );
  }
};
const handlePincodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;
  if (/^\d{0,6}$/.test(value)) {
    setFormValues(prev => ({
      ...prev,
      pincode: value,
    }));
    setPincodeError('');
  }
};
const handlePincodeBlur = async (event: React.FocusEvent<HTMLInputElement>) => {
  const { value } = event.target;
  setIsPincodeFocused(false);
  
  if (value.length !== 6) {
    setPincodeError('Pincode must be 6 digits');
    return;
  }

  setIsFetchingPincode(true);
  getPincode(
    formValues.pincode,
    (response) => {
      setIsFetchingPincode(false);
      if (response.city && response.state) {
        setFormValues(prev => ({
          ...prev,
          city: response.city,
          state: response.state
        }));
      }
    },
    (error) => {
      setIsFetchingPincode(false);
      console.log(error);
    }
  );
};

   const uploadFile = (type: string, file: File) => {
             if (file) {
                       addDocuments(
                        type === 'drivinglicense' ? file : null,
                        formValues.driving_license,
                        type === 'aadhar' ? file : null,
                        formValues.aadhar_number,
                        type === 'pancard' ? file : null,
                        type === 'backgroundverification' ? file : null,
                         null,
                         null,
                         null,
                         null,
                         ' ',
                         null,
                         null,
                        driverId,
                        (response) => {
                              setUploadedFiles((prevFiles) => ({
                                   ...prevFiles,
                                   [type]: { location: response.message.location, id: response.message.id }
                              }));
                              setDocumentLocation(response.message.location);
                              setDocumentState(1);
                              toast.success(`${response.message.document_name} uploaded successfully`);
                        },
                        (errMessage: any) => {  
                            if (errMessage && errMessage.status === 400) {
                                   let allErrorMessages: string[] = [];
                                   if (typeof errMessage.message === 'string') {
                                            allErrorMessages.push(errMessage.message);
                                            setSelectedFiles((prevFiles) => ({
                                              ...prevFiles,
                                              [type]: file
                                             }));
                                            setIcons((prevIcons) => ({
                                              ...prevIcons,
                                              [type]: 'view'
                                            }));
                                            toast.error(allErrorMessages.join(" "));
                                    } else if (errMessage.message && typeof errMessage.message === 'object') {
                                            const errors = errMessage.message.errors || {};
                                            for (const [key, messages] of Object.entries(errors)) {
                                               if (Array.isArray(messages)) {
                                                   allErrorMessages.push(...messages);
                                                }
                                            }
                                            setSelectedFiles((prevFiles) => ({
                                               ...prevFiles,
                                               [type]: null
                                            }));
                                            setIcons((prevIcons) => ({
                                               ...prevIcons,
                                               [type]: 'upload'
                                            }));
                                            toast.error(allErrorMessages.join(" "));
                                     }
                            } else {
                            toast.error("An unexpected error occurred.");
                           }
                     }
               );
          }
    };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, type: string) => {
    const fileInput = event.target; 
    const file = fileInput.files?.[0] || null;
    setSelectedFiles((prevFiles) => ({
        ...prevFiles,
        [type]: file
    }));
    
    setIcons((prevIcons) => ({
        ...prevIcons,
        [type]: file ? 'view' : 'upload'
    }));

    if (file) {
        if (file.size > maxFileSize) {
            toast.error("File size must not exceed 1 MB");
            setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: null
            }));
            setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'upload'
            })); 
            return;
        }
        if (!allowedFileTypes.includes(file.type)) {
            toast.error("File type not supported");
            setSelectedFiles((prevFiles) => ({
                ...prevFiles,
                [type]: null
            }));
            setIcons((prevIcons) => ({
                ...prevIcons,
                [type]: 'upload'
            }));
            return;
        }
        if (type === 'aadhar') {
            setAadharFilePending(file);
            if (!formValues.aadhar_number || !validateAadharNumber(formValues.aadhar_number).isValid) {
                setAadharNumberError("Aadhar file selected - please enter valid Aadhar number to complete upload");
            }
        } else if (type === 'drivinglicense') {
            setDrivingLicenseFilePending(file);
            if (!formValues.driving_license || !validateDrivingLicense(formValues.driving_license).isValid) {
                setDrivingLicenseError("Please enter valid Drivers License number to complete upload");
            }
        } else {
            uploadFile(type, file);
        }

    }
    fileInput.value = '';
};

    const handleIconClick = (type: string, action: string) => {
        if (action === 'view' ) {
            if (documentState===1){
              const url = documentLocation;
              window.open(`${global.documents_image_url}${url}`, '_blank');      }
            else if(documentState===2 ){ 
               const document = documentList.find(doc => doc.document_name.replace(' ', '').toLowerCase() === type.toLowerCase() && doc.status === 'uploaded');
               const url = document.location;
               console.log(document,url);
               window.open(`${global.documents_image_url}${url}`, '_blank');      } 
            else{
             toast.error('Document not found.');
            }
        } 
        else if (action === 'remove') {
            setDocumentToRemove(type);
            setIsConfirmationOpen(true);
            setDocumentDeleted(true);      
        }
    };

   const handleConfirmDelete = () => {
    if (documentToRemove && driverId) {
        let documentId: number | null = null;
        let documentTypeForApi = documentToRemove;
        if (documentState === 2) {
            const document = documentList.find(doc => 
                doc.document_name.replace(' ', '').toLowerCase() === documentToRemove.toLowerCase()
            );
            documentId = document?.id || null;
        } 
        else if (documentState === 1) {
            documentId = uploadedFiles[documentToRemove]?.id || null;
        }

        if (documentId) {
            deleteDocument(
                documentId,
                null,
                null,
                driverId, 
                (response) => {
                    toast.success(response?.message);
                    setSelectedFiles(prev => ({
                        ...prev,
                        [documentToRemove]: null
                    }));
                    setIcons(prev => ({
                        ...prev,
                        [documentToRemove]: 'upload'
                    }));
                    
                    if (documentState === 2) {
                        setDocumentList(prev => 
                            prev.filter(doc => 
                                doc.document_name.replace(' ', '').toLowerCase() !== documentToRemove.toLowerCase()
                            )
                        );
                    }
                    
                    if (documentToRemove === 'aadhar') {
                        setFormValues(prev => ({
                            ...prev,
                            aadhar_number: ''
                        }));
                    } else if (documentToRemove === 'drivinglicense') {
                        setFormValues(prev => ({
                            ...prev,
                            driving_license: ''
                        }));
                    }
                    if (documentToRemove === 'aadhar') {
                        setAadharFilePending(null);
                    } else if (documentToRemove === 'drivinglicense') {
                        setDrivingLicenseFilePending(null);
                    }
                },
                (errorMessage) => {   
                    toast.error(errorMessage.data?.message || 'Failed to delete document');
                }
            );
        } else {
            toast.error('Document ID not found');
        }
    } else {
        toast.error('Document not found.');
    }
    
    setDocumentToRemove(null);
    setIsConfirmationOpen(false);
};
   const renderFileInput = (label: string, type: string) => (
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <p style={{ fontSize: '17px', margin: 0, marginRight: '10px' }}>{label}</p>
          <input
            accept="*"
            style={{ display: 'none' }}
            id={`${type}-file`}
            type="file"
            onChange={(e) => handleFileChange(e, type)}
            />
       <label htmlFor={`${type}-file`}>
      <Tooltip title="Upload File">
        <IconButton color="primary" component="span">
          {icons[type] === 'upload' && <UploadIcon />}
        </IconButton>
      </Tooltip>
      </label>
      {icons[type] === 'view' && (
        <>
        <Tooltip title="View File">
          <span
            style={{ cursor: 'pointer', color: 'blue', marginRight: '10px' }}
            onClick={() => handleIconClick(type, 'view')}
          >
            View
          </span>
        </Tooltip>
        <Tooltip title="Remove File">
          <IconButton sx={{ color: 'black' }} component="span" onClick={() => handleIconClick(type, 'remove')}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
      )}
      </div>
    );



    const handleAadharNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;
  setFormValues(prev => ({
    ...prev,
    aadhar_number: value,
  }));

  if (value !== '' && value.length === 12) {
    const validation = validateAadharNumber(value);
    setAadharNumberError(validation.isValid ? '' : validation.error || 'Please enter a valid Aadhar number');
  }
  else if (value.length >12){
    setAadharNumberError(" Aadhar Number Must be 12 Digits");
      return;
  }
};

const handleAadharNumberBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const validation = validateAadharNumber(value);
    if (value.length>0 && value.length < 12){
      setAadharNumberError(" Aadhar Number Must be 12 Digits");
      return;
    }
   else  if (value.length === 12) {
        setAadharNumberError(validation.isValid ? '' : validation.error || 'Please enter a valid Aadhar number');
        
        if (aadharFilePending && validation.isValid) {
            uploadFile('aadhar', aadharFilePending);
            setAadharFilePending(null);
        }
    } else if (value.length > 12){
        setAadharNumberError(" Aadhar Number Must be 12 Digits"); 
    }
    else {
      setAadharNumberError("")
    }
};
 const handleDrivingLicenseChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value } = event.target;
  const validation = validateDrivingLicense(value);
  setDrivingLicenseError(validation.error || '');
  setFormValues(prev => ({
    ...prev,
    driving_license: validation.formattedValue || value,
  }));
};

const handleDrivingLicenseNumberBlur = (event: React.FocusEvent<HTMLInputElement>) => {
  const { value } = event.target;
  const validation = validateDrivingLicense(value);
  
  if (value !== '') {
    setDrivingLicenseError(validation.isValid ? '' : validation.error || 'Please enter a valid Drivers License number');

    if (drivingLicenseFilePending && validation.isValid) {
      uploadFile('drivinglicense', drivingLicenseFilePending);
      setDrivingLicenseFilePending(null);
    }
  } else {
    setDrivingLicenseError(''); 
  }
};
    useEffect(() => {
      if (open && driverId) {
        fetchDocuments();
      }
      if (driverData?.pincode) {
      setIsFetchingPincode(true);
      getPincode(
        driverData.pincode,
        (response) => {
          setIsFetchingPincode(false);
          if (response.city && response.state) {
            setFormValues(prev => ({
              ...prev,
              city: response.city,
              state: response.state
            }));
          }
        },
        (error) => {
          setIsFetchingPincode(false);
          console.log(error);
        }
      );
    }
      if (driverData || initialDocValues) {
        setFormValues({
          name: driverData?.name || '',
          location: driverData?.location || '',
          phone: driverData?.phone || '',
          whatsapp_number: driverData?.whatsapp_number || '',
          email: driverData?.email || '',
          aadhar_number: initialDocValues.aadhar_number || '',
          driving_license:initialDocValues.driving_license || '',
          pincode:driverData?.pincode || '',
           city: driverData?.city || '',
        state: driverData?.state || ''
        });
      }
    }, [driverData]);

    const handleCancelDelete = () => {
      setDocumentToRemove(null);
      setIsConfirmationOpen(false);
    };

   const handleSave = () => {
    if (nameError || emailError || whatsAppNumberError || locationError || aadharNumberError || pincodeError || drivingLicenseError ) {
        toast.error("Please fix the errors");
        return;
    }

    if (formValues.aadhar_number && !validateAadharNumber(formValues.aadhar_number).isValid) {
        setAadharNumberError('Aadhar number must be 12 digits');
        return;
    }

    const isSameData = (
        formValues.name === driverData?.name &&
        formValues.whatsapp_number === driverData?.whatsapp_number &&
        formValues.email === driverData?.email &&
        formValues.aadhar_number === initialDocValues?.aadhar_number &&
        formValues.driving_license === initialDocValues?.driving_license &&
        formValues.pincode === driverData?.pincode &&
        formValues.location === driverData?.location
    );

    if (isSameData) {
        handleClose();
        return;
    }

    const isDocChanged = (
        formValues.aadhar_number !== initialDocValues?.aadhar_number ||
        formValues.driving_license !== initialDocValues?.driving_license
    );
console.log(isDocChanged)
    const isDriverDataChanged = (
        formValues.name !== driverData?.name ||
        formValues.whatsapp_number !== driverData?.whatsapp_number ||
        formValues.email !== driverData?.email ||
        formValues.pincode !== driverData?.pincode ||
        formValues.location !== driverData?.location
    );
console.log(isDriverDataChanged)

    if (isDocChanged && !isDriverDataChanged) {
        editDocuments(
            null,
            formValues.driving_license,
            null,
            formValues.aadhar_number,
            null,
            null,
            null,
            null,
            null,
            '',
            '',
            driverId,
            (response) => {
                toast.success(response.message);
                onClose();
                setTimeout(() => {
                    fetchUsers(page, pageSize, null, null, null,null,null,null, 'driver');
                }, 2000);
            },
            (error) => {
                toast.error(error);
            }
        );
    }
    else if (!isDocChanged && isDriverDataChanged) {
        editDriver(
            formValues.name,
            formValues.email,
            formValues.whatsapp_number,
            formValues.location,
            formValues.pincode,
            countryCode,
            language,
            driverId,
            (response) => {
                toast.success(response.message);
                onClose();
                setTimeout(() => {
                    fetchUsers(page, pageSize, null, null, null,null,null,null, 'driver');
                }, 2000);
            },
            (error) => {
                toast.error(error);
            }
        );
    }
    else if (isDocChanged && isDriverDataChanged) {
        editDocuments(
            null,
            formValues.driving_license,
            null,
            formValues.aadhar_number,
            null,
            null,
            null,
            null,
            null,
            '',
            '',
            driverId,
            (response) => {
                toast.success(response.message);
                editDriver(
                    formValues.name,
                    formValues.email,
                    formValues.whatsapp_number,
                    formValues.location,
                    formValues.pincode,
                    countryCode,
                    language,
                    driverId,
                    (response) => {
                        toast.success(response.message);
                        onClose();
                        setTimeout(() => {
                            fetchUsers(page, pageSize, null, null, null,null,null,null, 'driver');
                        }, 2000);
                    },
                    (error) => {
                        toast.error(error);
                    }
                );
            },
            (error) => {
                toast.error(error);
            }
        );
    }
};
    const handleClose = () => {
        onClose();
        resetState();
    };

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value } = event.target;
      if (value === '') {
        setNameError('');
      } else if (validateDriverName(value)) {
        setNameError('');
      } else {
        setNameError('Characters are allowed');
      }
      setFormValues(prev => ({
        ...prev,
        name: value,
      }));
    };

    const handleEmailChange = (event: { target: { value: any; }; }) => {
        const { value } = event.target;
        setEmailError('');
        setFormValues(prev => ({
          ...prev,
          email: value,
      }));
    };

    const handleEmailBlur = () => {
        if (formValues.email === '') {
          setEmailError('');
        } else if (validateEmail(formValues.email)) {
          setEmailError('');
        } else {
          setEmailError('Please enter a valid email address.');
        }
    };

    const handlePhoneNumberBlur = () => {
      if (formValues.whatsapp_number === '') {
        setWhatsAppNumberError('');
      } else if (formValues.whatsapp_number.length>=1&&formValues.whatsapp_number.length<10) {
        setWhatsAppNumberError('Please enter a 10 digit number');
      } 
    };

    const handleNameBlur = () => {
        if (nameError=== '') {
          setNameError('');
        } else  {
          setNameError(nameError);
        } 
    };

    const handleLocationBlur = () => {
      if (locationError=== '') {
        setLocationError('');
      } else  {
        setLocationError(locationError);
      } 
    };

    const handleLocationChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { value } = event.target;
      if (value === '') {
        setLocationError('');
      }  else if (value.length > 180) {
        setLocationError('Location must be 180 characters or less');
      } else if (validateRemarks(value)) {
        setLocationError('');
      } else {
        setLocationError('Characters are allowed');
      }
      setFormValues(prev => ({
        ...prev,
        location: value,
      }));
    };  

    const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { value } = event.target;
        if(value==='')
        {
          setWhatsAppNumberError("");
        }
        else{
          const { errorMessage } = validatePhoneNumber(value);
          setWhatsAppNumberError(errorMessage);}
          setFormValues(prev => ({
             ...prev,
             whatsapp_number: value,
        }));
    };  

    return (
        <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { width: '800px', height: 'auto' } }}>
        <Box sx={{ marginLeft: {
      sm: '-180px', 
    }, }}>
            <Heading title={`Edit Driver - ${formValues.name}`} closeIcon="true" onClose={handleClose} />
          </Box>
        <DialogContent>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '10px 40px' }}>
            <TextField
              variant="outlined"
              size="small"
              label="Name"
              name="name"
              value={formValues.name}
              onChange={(e) => handleNameChange(e)}
              onBlur={handleNameBlur}
              error={!!nameError}
              helperText={nameError}
              style={{ width: '225px' }}
            />
            <TextField
              variant="outlined"
              size="small"
              label="Mobile Number"
              name="mobile_number"
              value={formValues.phone}
              disabled
              style={{ width: '225px' }}
            />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '10px 40px' }}>
               <TextField
              variant="outlined"
              size="small"
              label="WhatsApp Number"
              name="whatsapp_number"
              value={formValues.whatsapp_number}
              onChange={(e) => handlePhoneNumberChange(e)}
              onBlur={handlePhoneNumberBlur}
              error={!!whatsAppNumberError}
              helperText={whatsAppNumberError}
              style={{ width: '225px' }}
            />
            <TextField
              variant="outlined"
              size="small"
              label="Email"
              name="email"
              value={formValues.email}
              onChange={handleEmailChange}
              onBlur={handleEmailBlur}
              error={!!emailError}
              helperText={emailError}
              style={{ width: '225px' }}
            />
            
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '10px 40px' }}>
           
           <TextField
            variant="outlined"
            size="small"
            label="Pincode"
            name="pincode"
            value={formValues.pincode}
            onChange={handlePincodeChange}
            onBlur={handlePincodeBlur}
            error={!!pincodeError}
            helperText={pincodeError}
            disabled={isFetchingPincode}
            style={{ width: '225px' }}
            inputProps={{ maxLength: 6 }}
              />
            <TextField
              variant="outlined"
              size="small"
              label="State,City"
              name="state_city"
              value={`${formValues.city ? formValues.city + ', ' : ''}${formValues.state || ''}`}
              disabled
              sx={{ width: '225px' }}
            />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', margin: '10px 40px' }}>

            <TextField
              variant="outlined"
              size="small"
              label="Location"
              name="location"
              value={formValues.location}
              onChange={(e) => handleLocationChange(e)}
              onBlur={handleLocationBlur}
              error={!!locationError}
              helperText={locationError || `${formValues.location.length}/180 characters`}
              style={{ width: '225px' }}
              inputProps={{ maxLength: 180 }}
              multiline
              minRows={3}
              maxRows={6} 
            />
            </div>
            <div style={{ 
              display: 'flex', 
              alignItems: 'flex-start',
              gap: '20px', 
              margin: '10px 40px' 
            }}>
              <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
                    {renderFileInput('Aadhar Card', 'aadhar')}
               
               {renderFileInput('Driving License', 'drivinglicense')}
                 {renderFileInput('PAN Card', 'pancard')}
              </Box>
              
              <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start'
              }}>
              <TextField
                  variant="outlined"
                  size="small"
                  label="Aadhar Number"
                  name="aadhar_number"
                  value={formValues.aadhar_number}
                  onChange={handleAadharNumberChange}
                  onBlur={handleAadharNumberBlur}
                  error={!!aadharNumberError}
                  helperText={aadharNumberError}
                  style={{ width: '100%', marginBottom: '10px' }}
                  
                />
                 <TextField
                  variant="outlined"
                  size="small"
                  label="Driving License"
                  name="driving_license"
                  value={formValues.driving_license}
                  onChange={handleDrivingLicenseChange}
                  onBlur={handleDrivingLicenseNumberBlur}
                  error={!!drivingLicenseError}
                  helperText={drivingLicenseError}
                  style={{ width: '100%', marginBottom: '10px' }}
                
                />
              
                {renderFileInput('BGV (Background Verification)', 'backgroundverification')}
              </Box>
            </div>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className='custom-button' onClick={handleSave}>Save</Button>
            <Button className='custom-cancel-button' onClick={handleClose}>Cancel</Button>
        </DialogActions>
        <ConfirmationPopup
                    open={isConfirmationOpen}
                    onClose={handleCancelDelete}
                    onConfirm={handleConfirmDelete}
                    contentToDisplay=""
                    title="Confirm Deletion"
                    message={`Are you sure you want to delete the document?`}
        />
      </Dialog>
    );
};

export default EditDriverModal;